module.exports = __webpack_public_path__ + "static/media/kn-base-2.1faa355b.png";